import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import ContentSection from "../components/blocks/ContentSection";
import { H3 } from "../components/typography";
import Button from "../components/atoms/Button";
import Section from "../components/blocks/Section";
import Flex from "../components/blocks/Flex";
import Pad from "../components/blocks/Pad";
import Spacer from "../components/blocks/Spacer";
import Emphasis from "../components/atoms/Emphasis";
import GatsbyLink from "gatsby-link";

const CoupleSection = styled.div`
  display: flex;
  padding: 4rem 2rem;
  align-content: stretch;
  ${props => props.theme.media.mobile`
    padding: 1rem 0;
    padding-top: 500px;
  `};
`;

const CoupleImageWrapper = styled.div`
  flex: 1;
  img {
    width: 300px;
  }
  ${props => props.theme.media.mobile`
    position: absolute;
    top: 0;
    text-align: center;
    left: 0; 
    right: 0;
    img {
      height: 400px;
      width: auto;
      margin: 0 auto;
    }
  `};
`;

export default ({ content }) =>
  <Section>
    <CoupleSection>
      <Pad v={5} h={1} style={{ flex: 1 }}>
        <Emphasis />
        <ContentSection
          padding={false}
          bold={false}
          titleText={content.maleTitle}
          bodyText={[content.maleBody.maleBody]}
        />
      </Pad>
      <CoupleImageWrapper>
        <img src={content.coupleImage.responsiveResolution.src} />
      </CoupleImageWrapper>
      <Pad v={5} h={1} style={{ flex: 1 }}>
        <Emphasis align="flex-end" />
        <ContentSection
          padding={false}
          align={"right"}
          bold={false}
          titleText={content.femaleTitle}
          bodyText={[content.femaleBody.femaleBody]}
        />
      </Pad>
    </CoupleSection>
    <H3 align="center" style={{ width: "100%" }}>
      Interested in clinical trials?
    </H3>
    <Spacer span={0.5} />
    <Flex justify="center">
      <GatsbyLink to="/trials" style={{ textDecoration: "none" }}>
        <Button>Learn more</Button>
      </GatsbyLink>
    </Flex>
    <Spacer span={3} />
  </Section>;



// WEBPACK FOOTER //
// ./src/components/Couple.js